var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toJS } from "mobx";
export var stepReviewBusiness = function (_a) {
    var store = _a.store;
    var _b = store.newCreateRequestStore, questionsStore = _b.questionsStore, problemStore = _b.problemStore, detailStore = _b.detailStore, availabilityStore = _b.availabilityStore, homeStore = _b.homeStore, reviewStore = _b.reviewStore, recallCheckStore = _b.recallCheckStore, duplicateCheckStore = _b.duplicateCheckStore, newCreateRequestStore = store.newCreateRequestStore;
    var propsConnect = {
        currentUser: homeStore.currentUser,
        keyQuestionAnswers: questionsStore.keyQuestionsReviewData,
        troubleShootingAnswers: questionsStore.troubleShootingReviewData,
        detail: toJS(detailStore),
        problemCaseCadeName: toJS(problemStore.problemCaseCadeName),
        currentIconUrl: toJS(problemStore.currentIconUrl),
        availabilityData: toJS(availabilityStore.reviewAvailabilityTimeList),
        loading: newCreateRequestStore.loading,
        submitData: newCreateRequestStore.submitData,
        levelOneName: problemStore.levelOneName,
        levelTwoName: problemStore.levelTwoName,
        levelThreeName: problemStore.levelThreeName,
        isAliasingView: problemStore.isAliasingView,
        selectedAutoScheduleData: availabilityStore.selectedSchedule,
        showDisclaimer: reviewStore.showDisclaimer,
        targetDisclaimer: reviewStore.targetDisclaimer,
        originWO: recallCheckStore.originWO,
        duplicateWOList: duplicateCheckStore.duplicateWOList,
        availabilityStep: availabilityStore.availabilityStep,
    };
    var dispatchConnect = {
        submit: newCreateRequestStore.submit,
        getRegionScript: availabilityStore.getRegionScript,
        clearAllData: function () {
            detailStore.clear(),
                availabilityStore.clear();
            questionsStore.clear();
        },
        setDisclaimerData: reviewStore.setDisclaimerData,
        setAvailabilityParams: availabilityStore.setParams,
    };
    return __assign(__assign({}, dispatchConnect), propsConnect);
};
